import { Box } from '@mui/material';

function Home() {
  return <Box></Box>;
}

export default Home;
